import { useAuth } from "#/hook/useAuth";

export const usePermission = () => {
  const { canDelete, canWrite, canRead, user } = useAuth();

  return {
    canDelete,
    canWrite,
    canRead,
    permission: user?.clientPermission,
  };
};
